import Container from '@material-ui/core/Container';
import React from 'react';
import '../css/register.css';
import FooterCompanyLogo from '../images/color_logo_transparent.png';
import locale from '../locale/Localization';
import HelpIcon from './HelpIcon';

/**
 * Creates the footer.
 *
 * @return {string} with footer.
 */
export default function Footer() {
  return (
    <React.Fragment>
      <Container maxWidth='md'>
        <footer className='reg-footer'>
          <HelpIcon style={{color: 'white'}} />
          <div style={{marginTop: '14px', marginBottom: '14px'}}>
            <img src={FooterCompanyLogo} width='165' />
            <br />
            <div className='green-text'>
              {locale.footerAdditionalInformations}
            </div>
            <div>{locale.footerCompanyAddress}</div>
          </div>
        </footer>
      </Container>
    </React.Fragment>
  );
}
